import { functions } from '../../../config/firebase';
import { httpsCallable } from 'firebase/functions';

export async function generatePlaceImageByJSON(artStyle, jsonString, bookId = null, objectId = null) {
  const callable = httpsCallable(functions, 'generatePlaceImageByJSON', { timeout: 10000 });
  const resp = await callable({ artStyle, jsonString, bookId, objectId });
  return (resp && resp.data) || {};
}
